<div class="emds facility-portal fp-shell">

  <ap-alert></ap-alert>

  <div class="form-group">
    <div class="tabs tabs-default">
      <tabset>
        <tab id="{{Id}}-fp-search-tab-heading"
             heading="Patient Search">
          <fp-search class="tab-content"></fp-search>
        </tab>
        <tab id="{{Id}}-fp-message-tab-heading" heading="Messages ">
          <ng-template tabHeading>
            <span *ngIf="!isActiveDirectoryUser && unreadMessageCount && unreadMessageCount > 0 && !loadingUnreadMessageCounts" class="badge badge-danger">{{unreadMessageCount}} </span>
          </ng-template>
          <fp-message class="tab-content" [baseId]="Id" [unreadMessageCount] = "unreadMessageCount" (msgReload)="refreshUnreadMessageCount()"></fp-message>
        </tab>
        <tab id="{{Id}}-fp-appointments-tab-heading"
             heading="Appointments">
          <fp-appointments class="tab-content" [baseId]="Id"></fp-appointments>
        </tab>
      </tabset>
    </div>
  </div>

  <fp-document-printing></fp-document-printing>
</div>
